module.exports = __webpack_public_path__ + "static/media/earthid-logo.f5a4a546.png";